import { TYPE_WORD_PURE } from '@/contants/base';

export default () => ({
  convertData: [],
  currentSelection: null,
  removeInstanceFields: [],
  parentStyles: null,
  type: TYPE_WORD_PURE, // pure, template,
  options: {},
  globalStyles: {
    fontFamily: 'MS Mincho',
    fontSize: 12,
    lineHeight: 1.15
  }
})
